import { MouseEventHandler } from "react";
import * as AlfredoStyles from "../styles/layouts/layouts";

export function Menu(props: {
  onClick: MouseEventHandler<HTMLDivElement> | undefined;
}) {
  return (
    <AlfredoStyles.IconContainer>
      <AlfredoStyles.StyledIcon onClick={props.onClick}>
        <AlfredoStyles.MaterialIcons>menu_open</AlfredoStyles.MaterialIcons>
      </AlfredoStyles.StyledIcon>
    </AlfredoStyles.IconContainer>
  );
}
